@if (isOpen) {
  <app-faq-window (closed)="onClose()"></app-faq-window>
}
